/**
 * Created by intellicar-rinas on 19/4/18.
 */
/**
 * Created by intellicar-rinas on 22/9/17.
 */
import React, { Component } from "react";
import { connect } from "react-redux";
import "./DynamicGeofence.css";
import actions from "../../store/actions";
import moment from "moment";
import $ from "jquery";
// import mixpanel from "mixpanel-browser";

class LeftPane extends Component {
  state = {};

  polygons = {};

  constructor(props) {
    super(props);

    const applyMapEventPixelOffset = (e) => {
      e.pixel.y += 50;
      e.pixel.x += 50;
      return e;
    };

    this.mapMouseDown = (e) => {
      if (!this.props.DGeofence.active || this.DGeoObject) return;
      e = applyMapEventPixelOffset(e);

      let dom = $(
        "<div class='dynamicGeo' style='left:" +
          e.pixel.x +
          "px;top:" +
          e.pixel.y +
          "px'></div>"
      );
      this.DGeoObject = {
        dom,
        left: e.pixel.x,
        top: e.pixel.y,
        originEvent: e,
      };
      $("body").append(this.DGeoObject.dom);
    };

    this.mapMouseMove = (e) => {
      if (
        !this.props.DGeofence.active ||
        !this.DGeoObject ||
        !this.DGeoObject.dom
      )
        return;
      e = applyMapEventPixelOffset(e);
      this.DGeoObject.lastEvent = e;

      this.DGeoObject.width = e.pixel.x - this.DGeoObject.left;
      this.DGeoObject.currentLeft = this.DGeoObject.left;
      this.DGeoObject.xInverse = false;
      if (this.DGeoObject.width < 0) {
        this.DGeoObject.width = this.DGeoObject.left - e.pixel.x;
        this.DGeoObject.currentLeft = e.pixel.x;
        this.DGeoObject.xInverse = true;
      }
      this.DGeoObject.height = e.pixel.y - this.DGeoObject.top;
      this.DGeoObject.currentTop = this.DGeoObject.top;
      this.DGeoObject.yInverse = false;
      if (this.DGeoObject.height < 0) {
        this.DGeoObject.height = this.DGeoObject.top - e.pixel.y;
        this.DGeoObject.currentTop = e.pixel.y;
        this.DGeoObject.yInverse = true;
      }

      this.DGeoObject.dom.css({
        left: this.DGeoObject.currentLeft + "px",
        top: this.DGeoObject.currentTop + "px",
        width: this.DGeoObject.width + "px",
        height: this.DGeoObject.height + "px",
      });
    };

    this.mapMouseUp = (e) => {
      if (
        !this.props.DGeofence.active ||
        !this.DGeoObject ||
        !this.DGeoObject.dom
      )
        return;
      // e = applyMapEventPixelOffset(e);
      // this.DGeoObject.lastEvent = e;
      this.DGeoObject.dom.remove();
      delete this.DGeoObject.dom;

      if (!this.DGeoObject.lastEvent || !this.DGeoObject.originEvent) return;

      let leftTop = {
        lat: this.DGeoObject.xInverse
          ? this.DGeoObject.lastEvent.latLng.lat()
          : this.DGeoObject.originEvent.latLng.lat(),
        lng: this.DGeoObject.yInverse
          ? this.DGeoObject.lastEvent.latLng.lng()
          : this.DGeoObject.originEvent.latLng.lng(),
      };
      let rightBottom = {
        lat: !this.DGeoObject.xInverse
          ? this.DGeoObject.lastEvent.latLng.lat()
          : this.DGeoObject.originEvent.latLng.lat(),
        lng: !this.DGeoObject.yInverse
          ? this.DGeoObject.lastEvent.latLng.lng()
          : this.DGeoObject.originEvent.latLng.lng(),
      };

      this.DGeoObject.coords = [
        leftTop,
        { lat: rightBottom.lat, lng: leftTop.lng },
        rightBottom,
        { lat: leftTop.lat, lng: rightBottom.lng },
      ];
      this.DGeoObject.uid = "dgeo_" + moment().unix();
      this.DGeoObject.name = this.DGeoObject.uid;
      this.polygons[this.DGeoObject.uid] = new window.google.maps.Polygon({
        paths: this.DGeoObject.coords,
        strokeColor: "#5ac16c",
        strokeOpacity: 0.7,
        strokeWeight: 2,
        fillColor: "#098a23",
        fillOpacity: 0.25,
        draggable: true,
        uid: this.DGeoObject.uid,
        editable: true,
        map: window.map,
      });
      this.DGeoObject.poly = this.polygons[this.DGeoObject.uid];

      const setGeoByID = (ID) => {
        if (ID in this.props.DGeofence.geofences) {
          this.setGeo(this.props.DGeofence.geofences[ID]);
        }
      };

      window.google.maps.event.addListener(
        this.polygons[this.DGeoObject.uid],
        "click",
        function (event) {
          setGeoByID(this.uid);
        }
      );

      this.setGeo(this.DGeoObject);
    };

    this.getPoly = (geo) => {
      return this.polygons[geo.uid] || null;
    };

    this.addGeo = (geo) => {
      let data = { ...(this.props.DGeofence || { geofences: {} }).geofences };
      geo.completed = true;
      if (this.refs.nameinput.value) {
        geo.name = this.refs.nameinput.value;
      }
      if (this.getPoly(geo)) {
        this.getPoly(geo).setEditable(false);
        this.getPoly(geo).setDraggable(false);
      }
      data[geo.uid] = geo;
      this.props.dispatch({
        type: actions.UPDATE_DGEOFENCE,
        data,
      });
      this.DGeoObject = null;
      this.props.dispatch({
        type: actions.SET_DGEOFENCE_MODE,
        data: { active: false },
      });
      this.props.dispatch({
        type: actions.TOGGLE_LEFT_TREE,
        data: 2,
      });
    };

    this.setGeo = (geo) => {
      if (
        this.state.selectedGeo &&
        !this.state.selectedGeo.completed &&
        this.getPoly(this.state.selectedGeo)
      ) {
        this.getPoly(this.state.selectedGeo).setMap(null);
      }

      if (geo === null) {
        this.DGeoObject = null;
      } else if (this.getPoly(geo)) {
        this.getPoly(geo).setEditable(true);
        this.getPoly(geo).setDraggable(true);
      }

      this.setState({ selectedGeo: geo });
      if (this.refs.nameinput && geo) {
        this.refs.nameinput.value = geo.name;
      } else if (this.refs.nameinput) {
        this.refs.nameinput.value = "";
      }
    };

    const addMapEventListeners = () => {
      setTimeout(() => {
        if (window.addMapEventListener) {
          window.addMapEventListener(
            "leftPane",
            "mousedown",
            this.mapMouseDown
          );
          window.addMapEventListener(
            "leftPane",
            "mousemove",
            this.mapMouseMove
          );
          window.addEventListener("mouseup", this.mapMouseUp);
        } else {
          addMapEventListeners();
        }
      }, 1000);
    };

    addMapEventListeners();

    this.getSelectedGeo = () => {
      return this.state.selectedGeo || {};
    };

    this.updateGeo = () => {
      // mixpanel.track("User Creates Dynamic Geofence ", {
      //   Platform: "Web",
      //   Application: "Web",
      //   Screen: "Google Map",
      // });
      if (this.state.selectedGeo) {
        this.addGeo(this.state.selectedGeo);
        this.setGeo(null);
      }
    };

    this.deleteGeo = () => {
      if (
        this.state.selectedGeo &&
        this.state.selectedGeo.uid in this.props.DGeofence.geofences
      ) {
        let data = { ...(this.props.DGeofence || { geofences: {} }).geofences };
        delete data[this.state.selectedGeo.uid];
        this.setGeo(null);
        this.getPoly(this.state.selectedGeo).setMap(null);
        this.props.dispatch({
          type: actions.UPDATE_DGEOFENCE,
          data,
        });
      } else {
        this.setGeo(null);
      }
      this.props.dispatch({
        type: actions.SET_DGEOFENCE_MODE,
        data: { active: false },
      });
      // mixpanel.track("User Deletes Dynamic Geofence ", {
      //   Platform: "Web",
      //   Application: "Web",
      //   Screen: "Google Map",
      // });
    };
  }

  render() {
    return (
      <div className="DynamicGeofence">
        <div
          className={"dg-options " + (this.state.selectedGeo ? " active" : "")}
        >
          <div className="dgo-head">
            Dynamic Geofence Settings
            <div className="dgoh-close" onClick={() => this.setGeo(null)}>
              <i className="fa fa-times"></i>
            </div>
          </div>
          <div className="dgo-name">
            <div className="dgon-key">Dynamic Geofence Name</div>
            <div className="dgon-value">
              <input
                ref="nameinput"
                defaultValue={this.getSelectedGeo().name}
              />
            </div>
          </div>
          <div className="dgo-button" onClick={() => this.updateGeo()}>
            Apply
          </div>
          <div className="dgo-button -r" onClick={() => this.deleteGeo()}>
            Delete
          </div>
        </div>
      </div>
    );
  }
}

const MapPropsToState = (state) => {
  return {
    reportWindow: state.reportWindow,
    DGeofence: state.DGeofence,
  };
};

export default connect(MapPropsToState)(LeftPane);
